import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  getSelectedClientFromLocal,
  getSelectedBusinessUnitFromLocal,
  getLocalUser,
} from '@/services/session-data';
import { ACCESS_TYPE_CLIENT, USER_TYPE_DOCTOR } from '@/settings/consts/users';

const ChangeClientDialog$: BehaviorSubject<any> = new BehaviorSubject(
  'initialize',
);

const STATUS_SHOW = 'show';
const STATUS_HIDE = 'hide';

let selectedBusinessUnit: any = {
  razaoSocial: '',
  imagem: '',
};

function clientIsSelected(): void {
  getCurrentBusinessUnit();
  getSelectedClientFromLocal().subscribe((data) => {
    getLocalUser().subscribe((user) => {
      if (!data && user && user.tipoAcesso === ACCESS_TYPE_CLIENT) {
        // Nunca mostra a tela de unidades nas seguintes condições:
        // 1 - Se tiver 1 única unidade
        // 2 - Se não tiver uma empresa selecionada
        // 3 - se o usuário for um médico
        // tslint:disable-next-line: prettier
        if (user.listaUnidades.length > 1 && selectedBusinessUnit.cnpj !== undefined && user.tipoLogin !== USER_TYPE_DOCTOR) {
          show();
        } else {
          close();
        }
      }
    });
  });
}

function getCurrentBusinessUnit(): void {
  getSelectedBusinessUnitFromLocal().subscribe((data) => {
    if (!!data) {
      selectedBusinessUnit = data;
    }
  });
}

function show(): void {
  ChangeClientDialog$.next(STATUS_SHOW);
}

function close(): void {
  ChangeClientDialog$.next(STATUS_HIDE);
}

function get(): Observable<any> {
  return ChangeClientDialog$.pipe(filter((val) => val !== 'initialize'));
}

export { clientIsSelected, show, close, get, STATUS_SHOW, STATUS_HIDE };
